import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Button } from 'core-components/library/button'
import { NotificationController } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import { IPageWidget } from 'core-components/sitebuilder/models/IWidget'
import { EditButton } from 'core-components/sitebuilder/settings/wrapper/flexWrapperHeaderSettings/EditButton'
import { selectEditLayoutMode } from 'core-components/sitebuilder/store/selectors/selectEditLayoutMode'

import { SizeSelector } from '../../../layout/flexItem/SizeSelector'
import { WrapperActionsSelector } from '../../../layout/flexItem/WrapperActionsSelector'

import styles from './FlexWrapperHeaderSettings.module.scss'

interface IAdditionalHeadSettings {
  item: IFlexItem
  columnSize: FlexDirectionBreak
  updateItem: (newFlexItem: IFlexItem) => void
}

export const FlexWrapperHeaderSettings = ({
  item,
  columnSize,
  updateItem,
}: IAdditionalHeadSettings) => {
  const showLayout = useSelector(selectEditLayoutMode)

  const changeWrapperHandler = useCallback(() => {
    const allWidgets: IPageWidget[] =
      item.layoutSet?.items.reduce((prev, current) => {
        return prev.concat(current.widgets)
      }, [] as IPageWidget[]) || []

    if (allWidgets.length > 1) {
      return NotificationController.showError({
        message: `Can't convert to Widget, because it contains more than 1 widget inside`,
      })
    }

    updateItem({
      ...item,
      widgets: allWidgets,
      isFlexLayout: false,
    })
  }, [item])

  if (!showLayout || !item.layoutSet) {
    return null
  }

  return (
    <>
      {item.layoutSet.items.length < 2 ? (
        <Tooltip className={styles.tooltip} tipContent={() => <span>{'Change to widget'}</span>}>
          <Button
            iconButton={'kbase kbase-reload'}
            variant={'text'}
            color={'grey'}
            onClick={changeWrapperHandler}
          />
        </Tooltip>
      ) : null}

      <div className={styles.additionalHeadSettings}>
        <EditButton item={item} onChange={updateItem} />
        <SizeSelector item={item} value={columnSize} onChange={updateItem} />
        <WrapperActionsSelector item={item} updateItem={updateItem} />
      </div>
    </>
  )
}
